var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g(_vm._b({class:_setup.popoverCardRecipe(_setup.props),attrs:{"data-component":"CsPopoverCardContent","data-slot":"content","tabindex":"-1"}},'div',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }